import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
import {
  getToken
} from '@/utils/auth.js';
const router = new Router({
  mode: 'history',
  // base: '/student/',
  routes: [
    //登录
    {
      path: '/',
      name: 'Layout',
      component: () => import('@/components/Layout.vue'),
      children: [{
        path: '/',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
      }, {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index.vue'),
      }, {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
      }, {
        path: '/serves',
        name: 'serves',
        component: () => import('@/views/serves/index.vue'),
      }, {
        path: '/servesSearch',
        name: 'servesSearch',
        meta: {
          keepAlive: false, //代表需要缓存
        },
        component: () => import('@/views/serves/indexSearch.vue'),
      }, {
        path: '/newsList',
        name: 'newsList',
        component: () => import('@/views/newsList/index.vue'),
      }, {
        path: '/branch',
        name: 'branch',
        component: () => import('@/views/branch/index.vue'),
      }, {
        path: '/downLoad',
        name: 'downLoad',
        component: () => import('@/views/downLoad/index.vue'),
      }, {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/detail/index.vue'),
      }, ]
    },
    //首页
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: () => import('@/views/home/index.vue'),
    // },
    // //报名
    // {
    //   path: '/apply',
    //   name: 'apply',
    //   component: () => import('@/views/apply/index.vue'),
    // },
    // //学习记录
    // {
    //   path: '/study',
    //   name: 'study',
    //   component: () => import('@/views/study/index.vue'),
    // },
    // //查看已报名班级
    // {
    //   path: '/class',
    //   name: 'class',
    //   component: () => import('@/views/class/index.vue'),
    // },
    // //缴费记录
    // {
    //   path: '/pay',
    //   name: 'pay',
    //   component: () => import('@/views/pay/index.vue'),
    // },
    // //个人信息
    // {
    //   path: '/userinfo',
    //   name: 'userinfo',
    //   component: () => import('@/views/userinfo/index.vue'),
    // },
    // //通知公告
    // {
    //   path: '/notice',
    //   name: 'notice',
    //   component: () => import('@/views/notice/index.vue'),
    // },
    // {
    //   path: '/alipay',
    //   name: 'alipay',
    //   component: () => import('@/views/alipay/index.vue'),
    // },
    // //报名记录
    // {
    //   path: '/applyRecord',
    //   name:'applyRecord',
    //   component: () => import('@/views/applyRecord/index.vue')
    // },
    // //缴费记录
    // {
    //   path: '/payRecord',
    //   name:'payRecord',
    //   component: () => import('@/views/payRecord/index.vue')
    // },
    // //个人中心
    // {
    //   path: '/personal',
    //   name:'personal',
    //   component: () => import('@/views/personal/index.vue')
    // },
    // //关于我们
    // {
    //   path: '/aboutus',
    //   name:'aboutus',
    //   component: () => import('@/views/aboutus/index.vue')
    // },
  ]
})
// router.beforeEach((to, from, next)=>{
//   if(getToken()){   // 判断是否登录
//     if(to.path === '/' || to.path === '/login'){  //
//       //登录状态下 访问login.vue页面 会跳到index.vue
//       next({path: '/home'});
//     }else{
//       next();
//     }
//   }else{
//     // 如果没有session ,访问任何页面。都会进入到 登录页
//     if (to.path === '/') { // 如果是登录页面的话，直接next() -->解决注销后的循环执行bug
//       next();
//     } else { // 否则 跳转到登录页面
//       next({ path: '/' });
//     }
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js